import router, {
    resetRouter
} from './router'
import store from './store/'
import {
    Message,
    Loading
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
    getCookie,
    setCookie,
    delCookie,
    setSessionStorage,
    getSessionStorage
} from '@/utils/base'

NProgress.configure({
    showSpinner: false
})
const whiteList = ['/login', '/test', '/fonticon', '/register', '/resetpassword'];

// 在每个路由生效之前，先进行一些处理，请参考 vue-router官方文档-导航钩子
router.beforeEach(async (to, from, next) => {

    if (to.meta.title) {
        let title = '';
        let shop_name = getCookie('shop_name');
        if (shop_name && typeof (shop_name) != 'undefined') {
            document.title = to.meta.title + '-' + shop_name;
        } else {
            document.title = '物业协会职业技能等级认定报名';
        }
    }

    const isLogin = getCookie('isLogin_supplier');
    //判断是否登录
    if (isLogin) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next({path: '/'})
            NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
        } else {
            NProgress.start();
            let hasRoles = store.state.user.roles && store.state.user.roles.length > 0;
            if (hasRoles) {
                next();
                NProgress.done();
            } else {
                try {
                    //参数暂时无效
                    const roles = Math.random();
                    const accessRoutes = await store.dispatch('user/generateRoutes', roles);

                    resetRouter();

                    router.addRoutes(accessRoutes)

                    next({...to, replace: true})
                } catch (error) {
                    console.log(error);
                    next('/login');
                }
                NProgress.done()
            }
        }


    } else {
        if (whiteList.indexOf(to.path.toLowerCase()) !== -1) {
            next();
            NProgress.done();
        } else {
            next('/login');
        }
    }
})

/*注册一个全局守卫*/
router.beforeResolve((to, from, next) => {
    next();
})

/*全局后置钩子*/
router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js